import { useSearchParams } from "react-router-dom";
import { Music, Film } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { StudioImage } from "@/components/ui-nw/StudioImage";
import { SectionLabel } from "@/components/ui-nw/UserAvatar";
import { UploadForm } from "@/components/music/UploadForm";
import { VideoUploadForm } from "@/components/video/VideoUploadForm";
import { PlanPicker } from "@/components/membership/PlanPicker";
import { PAGES } from "@/constants/testIds";

export default function UploadPage() {
  const { profile, canUpload } = useProfile();
  const isCreator = profile.account_type === "creator";
  const [params, setParams] = useSearchParams();
  const type = params.get("type") === "video" ? "video" : "music";
  return (
    <div data-testid={PAGES.upload} className="grid gap-8 lg:grid-cols-[1fr_1.2fr] animate-rise">
      <div className="relative overflow-hidden rounded-3xl border border-white/10 min-h-[220px] lg:min-h-full flex items-end p-6">
        <StudioImage name="mic" eager alt="Chrome studio condenser microphone" sizes="(min-width: 1024px) 40vw, 100vw" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050508] via-black/50 to-transparent" />
        <div className="relative space-y-2">
          <SectionLabel>Upload</SectionLabel>
          <h1 className="font-display text-4xl font-extrabold tracking-tight chrome-text">Drop your work</h1>
          <p className="text-sm text-slate-300">Finished AI music and videos only — made in your tools, showcased on NEW WAVE.</p>
        </div>
      </div>
      {!canUpload ? (
        <div className="self-center">
          <PlanPicker title={isCreator ? "Unlock uploads" : "Become a Creator"}
            note={isCreator ? "Pick a plan to start uploading your AI music and videos." : "Your Fan account can listen and interact for free. Subscribe to upload your own AI music and videos."} />
        </div>
      ) : (
        <div className="space-y-5">
          <div className="inline-flex rounded-full border border-white/15 p-1" role="tablist">
            {[["music", "Music", Music], ["video", "Video", Film]].map(([id, label, Icon]) => (
              <button key={id} role="tab" aria-selected={type === id} data-testid={`upload-tab-${id}`} onClick={() => setParams(id === "video" ? { type: "video" } : {})}
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2 text-sm font-semibold transition-colors ${type === id ? "bg-nw-red text-white" : "text-slate-300 hover:text-white"}`}>
                <Icon className="h-4 w-4" /> {label}
              </button>
            ))}
          </div>
          {type === "video" ? <VideoUploadForm /> : <UploadForm />}
        </div>
      )}
    </div>
  );
}
